<!-- 百科详情 -->
<template>
    <div class="wrap">
        <div class="detail">
            <div class="detail-con" v-html="content">
            </div>
        </div>
    </div>
</template>

<script>
import { httpAgreementInfo } from "@/until/api";
import { type } from "os";
export default {
    data() {
        return {
            content: "",
            type: "",
        };
    },
    created: function () {
        httpAgreementInfo({}).then((res) => {
            if (res.code == 200) {
                this.content = res.data.aboutUs;
            }
        });
    },
    mounted: function () {
        this.init();
    },
    methods: {
        init(){
        },
    },
};
</script>

<style scoped>
.wrap {
    width: 100%;
    overflow: hidden;
}
.detail-con {
    width: 100%;
}
.detail-con >>> img{
    max-width: 100%; 
    width: 100%; 
    height: auto;
}
.detail-con >>> .ql-align-center {
    text-align: center;
}
</style>
